import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, size, space } from '../../theme/tokens';

export const PageContainer = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 0 ${layout.horizontalPadding};
`;

export const HeaderWrapper = styled.header<{ $bgColor?: string }>`
  background: ${(p) => p.$bgColor || semantic.bg.canvas};
  height: ${layout.headerHeightMobile};
  display: flex;
  align-items: center;
  padding: 0 ${layout.horizontalPadding};
  position: sticky;
  top: var(--announcement-banner-height, 0px);
  z-index: 100;
  border-bottom: 1px solid ${semantic.border.default};

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: ${layout.headerHeightDesktop};
  }
`;

export const HeaderInner = styled.div`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LogoLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  max-height: 50px;
  cursor: pointer;

  @media (min-width: ${layout.desktopBreakpoint}) {
    max-height: 70px;
  }
`;

export const PropertyName = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  color: ${semantic.text.primary};
  cursor: pointer;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size.xl};
  }
`;

export const BasketButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
  display: flex;
  align-items: center;
  gap: ${space['space-200']};
  padding: ${space['space-200']} ${space['space-300']};
  border-radius: ${size.radius['radius-xs']};

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const BasketBadge = styled.span`
  background: ${colors.primary};
  color: ${semantic.text.inverse};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.bold};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DesktopOnly = styled.div`
  display: none;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: block;
  }
`;

export const MobileOnly = styled.div`
  display: block;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;
